export const defaultReducer = (antState, newState) => {
    return {...antState, ...newState}
}

